import * as React from 'react';
import * as ReactDom from 'react-dom';
import { getContentPath } from './../../utils/api';

export interface ICountryAvailabilityProps {
	countries: SkodaAuto.Marvin.ServiceAvailability.Web.App.Models.Data.CodeListItemModel[];
	collapsible: boolean
}

export interface ICountryAvailabilityState {
	prevCountries: SkodaAuto.Marvin.ServiceAvailability.Web.App.Models.Data.CodeListItemModel[],
	countries: SkodaAuto.Marvin.ServiceAvailability.Web.App.Models.Data.CodeListItemModel[]
}

export class CountryAvailability extends React.Component<ICountryAvailabilityProps, ICountryAvailabilityState>
{
	constructor(props: ICountryAvailabilityProps) {
		super(props);

		this.state = {
			prevCountries: null,
			countries: props.countries
		};
	}

	static getDerivedStateFromProps(props: ICountryAvailabilityProps, state: ICountryAvailabilityState): ICountryAvailabilityState {
		let newState = { ...state };
		let hasChange = false;

		if (JSON.stringify(props.countries) != JSON.stringify(state.prevCountries)) {
			newState.prevCountries = props.countries;
			newState.countries = props.countries;
			hasChange = true;
		}

		if (hasChange)
			return newState;
		return null;
	}

	public render(): JSX.Element {
		return (
			<div className={'w-100 countries' + (this.props.collapsible ? ' collapse' : '')} id="collapseCountries">
				<div className="collapse-visible">
					{
						this.state.countries && this.state.countries.map((country) =>
							<div className="country col-lg-8 col-md-12 col-sm-24" key={'country_' + country.Code}>
								<table>
									<tbody>
										<tr>
											<td>
												<img className="country-flags-image" src={getContentPath() + 'img/flags/' + country.Code.toLowerCase() + '.svg'} alt={country.Value} />
											</td>
											<td>
												{
													country.Value && country.Value.length > 30 ?
														<p title={country.Value} className='multiline-elipsis title'>{country.Value}</p> : 
														<p className='title'>{country.Value}</p>
												}
											</td>
										</tr>
									</tbody>
								</table>
							</div>
						)
					}
				</div>
			</div>
		);
	}
}